import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

const zhCNMessages = {
  "edu.pages.members.title": "成员管理",
  "edu.pages.members.subtitle": "这里承接 edu 本地成员范围治理，统一成员准入、角色组合和业务选人边界。",
  "edu.pages.members.notice": "未纳入 edu 本地成员范围的用户，不应进入 edu 课程、教学计划或培训项目的正式选人主链。",
  "edu.pages.members.messages.loadFailed": "成员管理加载失败",
  "edu.pages.members.messages.detailLoadFailed": "成员详情加载失败",
  "edu.pages.members.messages.selectCandidatesFirst": "请先从统一身份组织树中选择成员",
  "edu.pages.members.messages.createSuccess": "已纳入 {count} 名成员",
  "edu.pages.members.messages.createFailed": "新增成员失败",
  "edu.pages.members.messages.rolesUpdated": "已更新 {name} 的角色组合",
  "edu.pages.members.messages.rolesUpdateFailed": "角色更新失败",
  "edu.pages.members.messages.deleteSuccess": "已移除成员：{name}",
  "edu.pages.members.messages.deleteFailed": "成员移除失败",
  "edu.pages.members.confirm.removeTitle": "移除成员：{name}",
  "edu.pages.members.confirm.removeDescription": "移除后，该成员会退出 edu 本地成员范围，但不会影响统一身份账号。",
  "edu.pages.members.labels.member": "成员",
  "edu.pages.members.labels.roles": "角色",
  "edu.pages.members.labels.orgPath": "所属范围",
  "edu.pages.members.labels.selectionScope": "选人边界",
  "edu.pages.members.labels.learningScope": "当前学习/负责",
  "edu.pages.members.labels.focusItems": "当前关注",
  "edu.pages.members.labels.currentDetail": "当前成员详情",
  "edu.pages.members.labels.assignments": "当前参与 / 负责",
  "edu.pages.members.labels.nextActions": "下一步入口",
  "edu.pages.members.labels.email": "邮箱",
  "edu.pages.members.labels.membership": "成员准入",
  "edu.pages.members.labels.roleBoundary": "角色边界",
  "edu.pages.members.labels.assistantScope": "助教范围",
  "edu.pages.members.labels.defaultRoles": "纳入后的默认角色",
  "edu.pages.members.labels.selectedCount": "已选择 {count} 名成员",
  "edu.pages.members.labels.noCandidates": "尚未选择成员",
  "edu.pages.members.labels.selectedMembers": "已选成员",
  "edu.pages.members.labels.name": "姓名",
  "edu.pages.members.labels.orgTree": "组织树",
  "edu.pages.members.labels.pendingMembers": "待纳入成员",
  "edu.pages.members.labels.roleStudent": "学员",
  "edu.pages.members.labels.roleTeacher": "教员",
  "edu.pages.members.labels.roleAssistant": "助教",
  "edu.pages.members.labels.roleAdmin": "管理员",
  "edu.pages.members.placeholders.emptyList": "当前还没有纳入任何 edu 成员。",
  "edu.pages.members.placeholders.emptyDetail": "请选择一个成员查看详情，或先新增一位 edu 成员。",
  "edu.pages.members.placeholders.emptyAssignments": "当前没有参与中的课程、计划或项目。",
  "edu.pages.members.placeholders.searchName": "搜索姓名",
  "edu.pages.members.placeholders.searchOrgPath": "搜索组织范围",
  "edu.pages.members.drawer.createTitle": "新增 edu 成员",
  "edu.pages.members.drawer.rolesTitle": "修改角色",
  "edu.pages.members.drawer.createDescription": "先从统一身份组织树中多选成员，回到当前抽屉预览后再确认纳入 edu 本地成员范围。",
  "edu.pages.members.drawer.rolesDescription": "这里更新的是 edu 本地业务角色组合，不会改动平台统一账号或全局身份目录。",
  "edu.pages.members.drawer.defaultSummary": "已纳入 edu 本地成员范围，可被课程、教学计划与培训项目选人链路继续引用。",
  "edu.pages.members.buttons.confirmAdd": "确认纳入",
  "edu.pages.members.buttons.saveRoles": "保存角色",
  "edu.pages.members.modals.identityPickerTitle": "从统一身份中心添加成员",
  "edu.pages.members.modals.identityPickerSubmit": "带回已选成员",
  "edu.pages.members.forms.rolesRequired": "请至少选择一个角色",
  "edu.pages.login.bootstrapTitle": "正在检测登录状态",
  "edu.pages.login.bootstrapDescription": "EDU 教学后台通过 AIRange OIDC 单点登录进入。",
  "edu.pages.login.noSessionTitle": "需要登录",
  "edu.pages.login.noSessionDescription": "请先通过统一身份中心登录，再进入 EDU 教学后台。",
  "edu.pages.login.noAccessTitle": "没有后台访问权限",
  "edu.pages.login.noAccessDescription": "当前账号还没有 EDU 后台角色，请联系 EDU 管理员授权。",
  "edu.pages.login.portalAction": "进入学员端",
  "edu.pages.login.enterAction": "进入后台",
  "edu.pages.login.switchIdentityAction": "去登录",
  "edu.pages.login.redetectAction": "重新检测",
  "edu.pages.oidc.status.pending": "正在完成 OIDC 登录...",
  "edu.pages.oidc.status.missingCodeState": "OIDC 回调缺少 code/state 参数",
  "edu.pages.oidc.status.sessionInitFailed": "EDU 后台本地会话初始化失败",
  "edu.pages.oidc.status.callbackFailed": "OIDC 回调失败",
  "edu.pages.notFound.subtitle": "页面不存在或当前无法访问。",
  "edu.pages.orgs.title": "组织管理",
  "edu.pages.orgs.subtitle": "这里治理的是 edu 自己的独立组织树，承接批量选人包装、范围筛选与统计观察。",
  "edu.pages.orgs.notice": "组织节点用于成员归属与选人边界，不直接替代教学计划或培训项目中的正式执行主体。",
  "edu.pages.orgs.messages.loadFailed": "组织管理加载失败",
  "edu.pages.orgs.messages.detailLoadFailed": "组织详情加载失败",
  "edu.pages.orgs.labels.node": "组织节点",
  "edu.pages.orgs.labels.path": "路径",
  "edu.pages.orgs.labels.memberCount": "成员",
  "edu.pages.orgs.labels.childCount": "下级节点",
  "edu.pages.orgs.labels.usage": "主要用途",
  "edu.pages.orgs.labels.childNodes": "下级节点",
  "edu.pages.orgs.labels.nextActions": "下一步入口",
  "edu.pages.orgs.labels.focusItems": "当前关注",
  "edu.pages.orgs.labels.currentDetail": "当前组织详情",
  "edu.pages.orgs.labels.description": "组织说明",
  "edu.pages.orgs.labels.structure": "结构边界",
  "edu.pages.orgs.labels.selection": "选人边界",
  "edu.pages.orgs.labels.binding": "成员绑定",
  "edu.pages.orgs.labels.sync": "同步边界",
  "edu.pages.orgs.placeholders.emptyDetail": "请选择一个组织节点查看详情。",
  "edu.pages.orgs.placeholders.emptyChildNodes": "当前组织节点下没有子节点。",
  "edu.pages.orgs.placeholders.searchCreatedBy": "搜索创建人用户名",
  "edu.pages.orgs.placeholders.searchUpdatedBy": "搜索修改人用户名",
} satisfies MessageTree;

export const eduMembersAuthOrgsPageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": zhCNMessages,
  en: zhCNMessages,
  ja: zhCNMessages,
};
